const carouselItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20dramatic%20scene%2C%20couple%20embracing%20under%20cherry%20blossoms%20at%20sunset%2C%20warm%20orange%20and%20pink%20color%20palette%2C%20digital%20illustration%2C%20emotional%20atmosphere%2C%20cinematic%20lighting%2C%20Korean%20webtoon%20art%20style&width=800&height=420&seq=carousel-manhwa-01&orientation=landscape',
    tag: '专题推荐',
    tagColor: 'bg-primary-100/90 text-primary-700',
    title: '2026夏季韩漫必读 · 校园恋爱精选',
    desc: '精选10部高口碑校园恋爱韩漫，从青梅竹马到重逢心动，每一部都值得细细品味',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20epic%20battle%20scene%2C%20magical%20warrior%20fighting%20dragon%2C%20dramatic%20warm%20gold%20and%20crimson%20lighting%2C%20digital%20art%2C%20dynamic%20composition%2C%20cinematic%20quality%2C%20Korean%20illustration%20style&width=800&height=420&seq=carousel-manhwa-02&orientation=landscape',
    tag: '编辑精选',
    tagColor: 'bg-accent-100/90 text-accent-700',
    title: '奇幻冒险韩漫入坑指南 · 异世界篇',
    desc: '从转生到逆袭，从剑术到魔法，盘点近年最值得追的异世界题材佳作',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20noir%20scene%2C%20detective%20looking%20at%20evidence%20board%20in%20dim%20room%2C%20warm%20amber%20light%20through%20blinds%2C%20suspenseful%20mood%2C%20digital%20art%2C%20cinematic%20composition%2C%20Korean%20illustration%20style&width=800&height=420&seq=carousel-manhwa-03&orientation=landscape',
    tag: '深度解析',
    tagColor: 'bg-secondary-100/90 text-secondary-700',
    title: '悬疑韩漫封神榜 · 那些烧脑到停不下来的作品',
    desc: '反转再反转，每一话都在挑战读者的推理能力，悬疑迷不可错过的经典盘点',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20fantasy%20royal%20palace%20scene%2C%20princess%20in%20elegant%20dress%20standing%20in%20grand%20hall%2C%20warm%20golden%20chandelier%20lighting%2C%20digital%20art%2C%20luxurious%20atmosphere%2C%20cinematic%20quality%2C%20Korean%20illustration%20style&width=800&height=420&seq=carousel-manhwa-04&orientation=landscape',
    tag: '新作速递',
    tagColor: 'bg-primary-100/90 text-primary-700',
    title: '恶役千金韩漫崛起 · 反派视角的新浪漫',
    desc: '转生为反派的千金们如何改写命运？盘点近期最火爆的恶役千金题材韩漫新作',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            布丁漫画编辑团队精心策划的韩漫专题内容，深度解读热门作品与题材趋势
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group relative rounded-2xl overflow-hidden cursor-pointer"
            >
              <div className="aspect-[16/9] md:aspect-[2/1] relative overflow-hidden">
                <img
                  src={item.img}
                  alt={`布丁漫画焦点专题 — ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className={`inline-flex items-center px-2.5 py-0.5 text-xs font-medium rounded-full ${item.tagColor} mb-2`}>
                  {item.tag}
                </span>
                <h3 className="font-heading text-base md:text-xl font-bold text-background-50 leading-snug">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-background-50/80 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}